/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Delete_Success_DescriptionInputs */

const es_admin_users_delete_success_description = /** @type {(inputs: Admin_Users_Delete_Success_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El usuario fue eliminado correctamente de tu empresa.`)
};

const en_admin_users_delete_success_description = /** @type {(inputs: Admin_Users_Delete_Success_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The user was successfully removed from your company.`)
};

/**
* | output |
* | --- |
* | "The user was successfully removed from your company." |
*
* @param {Admin_Users_Delete_Success_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_delete_success_description = /** @type {((inputs?: Admin_Users_Delete_Success_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Delete_Success_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_delete_success_description(inputs)
	return en_admin_users_delete_success_description(inputs)
});
export { admin_users_delete_success_description as "admin.users.delete.success.description" }